import { lazy, Suspense } from 'react';

import { ListSkeleton } from '@/shared/components/skeletons';

/*
 * Components the module contributes to other pages (the chat tab of a workgroup), loaded on first use so the chat view,
 * its editor and the call code stay out of the main bundle.
 */
const GroupChatTabLazy = lazy(async () => ({
  default: (await import('./components/GroupChatTab')).GroupChatTab,
}));

export function GroupChatTabEntry({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={6} />}>
      <GroupChatTabLazy groupId={groupId} />
    </Suspense>
  );
}
